import { useCallback, useRef, useState } from "react";

export default function useRecorder() {
  const [recording, setRecording] = useState(false);
  const [error, setError] = useState(null);
  const mediaRef = useRef(null);
  const chunksRef = useRef([]);

  const start = useCallback(async () => {
    setError(null);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mime = MediaRecorder.isTypeSupported("audio/webm")
        ? "audio/webm"
        : MediaRecorder.isTypeSupported("audio/mp4")
        ? "audio/mp4"
        : "";
      const mr = mime ? new MediaRecorder(stream, { mimeType: mime }) : new MediaRecorder(stream);
      chunksRef.current = [];
      mr.ondataavailable = (e) => {
        if (e.data && e.data.size) chunksRef.current.push(e.data);
      };
      mr.start();
      mediaRef.current = { mr, stream };
      setRecording(true);
    } catch (e) {
      setError(e.message || "Could not access microphone");
    }
  }, []);

  const stop = useCallback(
    () =>
      new Promise((resolve) => {
        const current = mediaRef.current;
        if (!current) {
          resolve(null);
          return;
        }
        const { mr, stream } = current;
        mr.onstop = () => {
          const type = mr.mimeType || "audio/webm";
          const blob = new Blob(chunksRef.current, { type });
          stream.getTracks().forEach((t) => t.stop());
          mediaRef.current = null;
          setRecording(false);
          resolve(blob);
        };
        mr.stop();
      }),
    []
  );

  return { recording, error, start, stop };
}
